<template lang="pug">
  .component-ranger-picker
    v-md-date-range-picker(:show-activator-label="false", @change="rangeSelected", :start-date="startDate", :end-date="endDate", :showYearSelect="true")
      input(disabled :value="textLabel", slot="input")

</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'RangePicker',
    data() {
      return {
        //label: 'Select dates',
        rangeLabel: null
      }
    },
    props: {
      value: {},
      startDate: {type: String},
      endDate: {type: String},
      label: {
        type: String,
      }
    },
    methods: {
      rangeSelected(date) {
        this.rangeLabel = `${date[0].format('YYYY-MM-DD')} - ${date[1].format('YYYY-MM-DD')}`
        this.$emit('input', {from: date[0].format('YYYY-MM-DD'), to: date[1].format('YYYY-MM-DD')})
      }
    },
    computed: {
      ...mapState({
        configuration: state => state.configuration,
      }),
      dateFormat() {
        return this.$toMomentFormat(this.configuration.locale.locale_date_format.value)
      },
      textLabel() {
        const selectedRange = this.startDate !== undefined && this.endDate !== undefined
        if (this.rangeLabel !== null) {
          return this.rangeLabel
        }
        return selectedRange ? `${this.startDate} - ${this.endDate}` : 'Select date range'
      }
    }
  }
</script>

<style lang="sass">
  .component-ranger-picker
    input:disabled
      background-color: white
      border: 0
      border-radius: 5px
</style>



// WEBPACK FOOTER //
// RangePicker.vue?6953ac04